import { render, staticRenderFns } from "./ResolutionCenter.vue?vue&type=template&id=1c521c16&scoped=true&"
import script from "./ResolutionCenter.vue?vue&type=script&lang=js&"
export * from "./ResolutionCenter.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionCenter.vue?vue&type=style&index=0&id=1c521c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c521c16",
  null
  
)

export default component.exports